import { render, staticRenderFns } from "./WorkflowFormSubmissionCommentCard.vue?vue&type=template&id=3b3eb013&"
import script from "./WorkflowFormSubmissionCommentCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionCommentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports